import axios from 'axios';
import errorHandlerFactory from './errorHandler';

const errorHandler = errorHandlerFactory('An error occured when trying to save configurations.');

export const saveConfiguration = (section, preference) => axios.post('/UserPreference/SaveUserConfiguration',
    { section, preference })
    .then(r => r.data).catch(errorHandler);

export const getConfiguration = section => axios.get('/UserPreference/GetUserConfiguration', { params: { section } })
    .then(r => r.data).catch(errorHandler);
